const strings = {
  switchToLight: 'Light mode',
  switchToDark:  'Dark mode',
  label:         'Toggle colour theme',
};

export default strings;
